export const socialMediaViewsArticle = {
  title: 'Social Media Planner: Views & Accounts',
  slug: 'social-media-views',
  content: `Social Media Planner: Views & Accounts

Use the side navigation to switch between planner views.

1) Calendar & Queue
- Calendar shows scheduled posts by date.
- Queue lists upcoming posts and status.

2) Analytics & Media
- Analytics summarizes performance.
- Media library stores assets used in posts.

3) Campaigns & Accounts
- Campaigns group posts by initiative.
- Accounts lets you connect and manage social accounts.
`,
};
